import React from 'react'
import {Link}  from 'react-router-dom'
import Logo from '../../images/official_logo.png'
import journal2025 from '../../images/journals/4.png'
import journal2023 from '../../images/journals/3.png'
import './style.css'

const Footer = (props) =>{

    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }

  return(
    <footer className="wpo-site-footer">
        <div className="wpo-upper-footer">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                        <div className="widget about-widget">
                            <div className="logo widget-title">
                                <img src={Logo} alt=""/>
                            </div>
                            <p>Nirbaak - A cultural organization dedicated to spreading awareness through the art of mime performance since 2018.</p>
                            <ul>
                                <li><Link target='_blank' to="https://www.facebook.com/profile.php?id=100007519275132"><i className="ti-facebook"></i></Link></li>
                                {/* <li><Link onClick={ClickHandler} to="/home"><i className="ti-twitter-alt"></i></Link></li> */}
                                <li><Link target='_blank' to="https://www.instagram.com/mime_minangka/"><i className="ti-instagram"></i></Link></li>
                                <li><Link target='_blank' to="https://www.youtube.com/@NirbaakProduction"><i className="ti-youtube"></i></Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                        <div className="widget link-widget resource-widget">
                            <div className="widget-title">
                                <h3>Journals</h3>
                            </div>
                            <div className="news-wrap">
                                <div className="news-img">
                                    <a href="https://pub-2e62b0f5d6654391b41413db98565a70.r2.dev/2025.pdf" target="_blank" rel="noopener noreferrer">
                                        <img src={journal2025} alt="Journal 2025"/>
                                    </a>
                                </div>
                                <div className="news-text">
                                    <h3><a href="https://pub-2e62b0f5d6654391b41413db98565a70.r2.dev/2025.pdf" target="_blank" rel="noopener noreferrer">Journal 2025</a></h3>
                                </div>
                            </div>
                            <div className="news-wrap">
                                <div className="news-img">
                                    <a href="https://pub-2e62b0f5d6654391b41413db98565a70.r2.dev/2023.pdf" target="_blank" rel="noopener noreferrer">
                                        <img src={journal2023} alt="Journal 2023"/>
                                    </a>
                                </div>
                                <div className="news-text">
                                    <h3><a href="https://pub-2e62b0f5d6654391b41413db98565a70.r2.dev/2023.pdf" target="_blank" rel="noopener noreferrer">Journal 2023</a></h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col col-lg-2 col-md-6 col-sm-12 col-12">
                        <div className="widget link-widget">
                            <div className="widget-title">
                                <h3>Useful Links</h3>
                            </div>
                            <ul>
                                <li><Link onClick={ClickHandler} to="/about">About Us</Link></li>
                                <li><Link onClick={ClickHandler} to="/contact">Contact Us</Link></li>
                                <li><Link onClick={ClickHandler} to="/awards">Awards</Link></li>
                                <li><Link onClick={ClickHandler} to="/event">Activites</Link></li>
                                <li><Link onClick={ClickHandler} to="/Journals">Journals</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col col-lg-3 offset-lg-1 col-md-6 col-sm-12 col-12">
                        <div className="widget market-widget wpo-service-link-widget">
                            <div className="widget-title">
                                <h3>Contact </h3>
                            </div>
                            <p>Connect with us to know more about our mime performances and social awareness programs</p>
                            <div className="contact-ft">
                                <ul>
                                    <li><i className="fi flaticon-pin"></i>West Boragaon, Near Bangshi Gopal Namghar Path,
                                    Guwahati, Assam, India</li>
                                    <li><i className="fi flaticon-call"></i>+91 8486322013/ 8638453757</li>
                                    <li><i className="fi flaticon-envelope"></i>nirbaakworld@gmail.com</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="wpo-lower-footer">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <p className="copyright">&copy; 2025 Nirbaak. All rights reserved.</p> <br/>
                        <p className="copyright">Developed by <a href="https://viragotales.com" target="_blank" rel="noopener noreferrer">Virago Tales.</a></p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
  )
} 

export default Footer;